<template>
  <div class="clearfix" v-if="!pageLoad">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="pageLoad" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <input
          v-model="searchQuery"
          type="text"
          class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
          :placeholder="$t('contacts.search')"
        />
      </div>
      <div class="d-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#companyModal"
          style="background-color: #EB9355;"
          @click="initField"
          v-if="current_permissions('create_contact')"
        >
          {{ $t('contacts.addContact') }}
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#importContact"
          @click="initField"
          v-if="current_permissions('create_contact')"
        >
          {{ $t('contacts.massImport') }}
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('contacts.code') }}
              </th>
              <th v-if="current_permissions('SUPERADMIN')" scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('contacts.organization') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('contacts.firstName') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('contacts.lastName') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('contacts.phoneNumber') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(contact) in paginatedContacts" :key="contact.code">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ contact.code }}
              </td>
              <td v-if="current_permissions('SUPERADMIN')" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ contact.organization?.name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ contact.first_name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ contact.last_name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ contact.contact}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#companyModal1" @click="showTransfert(contact.code)">
                        <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
                        <span class="">{{ $t('contacts.transfer') }}</span>
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center" style="color: red;" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#filterLeadModal" @click="showScreen(contact.code)" v-if="current_permissions('delete_contact')">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        <span class="">{{ $t('contacts.delete') }}</span>
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#companyModal" @click="showContact(contact.code)" v-if="current_permissions('edit_contact')">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        <span class="">{{ $t('contacts.edit') }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="filteredTotal>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p v-if="filteredTotal>pageSize" class="mb-0 text-paragraph">
          {{ $t('contacts.showing') }} <span class="fw-bold">{{ showingFrom }}-{{ showingTo }}</span> {{ $t('contacts.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('contacts.results') }}
        </p>
        <p v-if="filteredTotal<=pageSize" class="mb-0 text-paragraph">
          {{ $t('contacts.showing') }} <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('contacts.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('contacts.results') }}
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="goToPage(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="goToPage(numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="goToPage(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Delete Confirmation -->
  <div class="modal fade" id="filterLeadModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ $t('contacts.alert') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancel()"></button>
        </div>
        <div class="modal-body">
          <div style="">
            <h6 v-if="errors==''" class="text-red fw-bold mb-0 text-center" style="color: red;">{{ $t('contacts.confirmDelete') }}</h6>
          </div>
          <div v-if="errors!==''">
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">code: {{ errorId}}</h6>
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn default-outline-btn bg-transparent" style="background-color: #FFF;" data-bs-dismiss="modal" @click="cancel()">
            {{ $t('contacts.no') }}
          </button>
          <button :disabled="!btnLoad" type="button" class="btn" style="background-color: #EB9355;" @click="deleteContact()">
            <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
            <span style="color: #FFF;">{{ $t('contacts.yes') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Create/Edit Contact -->
  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="save">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ edit == 0 ? $t('contacts.addContact') : $t('contacts.editContact') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('contacts.phoneNumber') }}</label>
                  <div>
                    <input type="text" v-model="formValues.phone" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('contacts.phonePlaceholder')" :class="{ 'is-invalid': errorsBis['phone'] }" id="phone" @keyup="handlePhone($event.target.value,$event.target)" @blur="handlePhone($event.target.value,$event.target)" />
                    <span class="invalid-feedback">{{ errorsBis['phone']}}</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('contacts.firstName') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('contacts.firstNamePlaceholder')" v-model="formValues.first_name" :class="{ 'is-invalid': errorsBis['first_name'] }" id="first_name" @blur="validate('first_name')" />
                    <span class="invalid-feedback">{{ errorsBis['first_name']}}</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('contacts.lastName') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('contacts.lastNamePlaceholder')" v-model="formValues.last_name" :class="{ 'is-invalid': errorsBis['last_name'] }" id="last_name" @blur="validate('last_name')" />
                    <span class="invalid-feedback">{{ errorsBis['last_name']}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn text-white" style="background-color: #EB9355;" v-if="current_permissions('create_contact')">
              <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ edit == 0 ? $t('contacts.save') : $t('contacts.edit') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Modal Transfer Money -->
  <div class="modal fade" id="companyModal1" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="sendMoney">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('contacts.transferMoney') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div style="margin-bottom: 5%;">
              <h6 class="text-black fw-bold mb-0 text-center">{{ $t('contacts.balance') }}</h6>
              <h6 class="text-black fw-bold mb-0 text-center" style="color: red;">{{ payoutBalance?.toLocaleString()}} XOF</h6>
            </div>
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('contacts.phoneNumber') }}</label>
                  <div>
                    <input type="text" v-model="formValues.phone" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('contacts.phonePlaceholder')" :class="{ 'is-invalid': errorsBis['phone'] }" id="phone_transfer" readonly />
                    <span class="invalid-feedback">{{ errorsBis['phone']}}</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('contacts.firstName') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('contacts.firstNamePlaceholder')" v-model="formValues.first_name" :class="{ 'is-invalid': errorsBis['first_name'] }" readonly />
                    <span class="invalid-feedback">{{ errorsBis['first_name']}}</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('contacts.lastName') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('contacts.lastNamePlaceholder')" v-model="formValues.last_name" :class="{ 'is-invalid': errorsBis['last_name'] }" readonly />
                    <span class="invalid-feedback">{{ errorsBis['last_name']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('contacts.operators') }}</label>
                  <select name="operator" id="operator" class="form-select fs-md-15 text-black shadow-none" @change="handleOperatorChange" required>
                    <option value="">{{ $t('contacts.select') }}</option>
                    <option v-for="operator in operators" :value="operator.mnoName" :key="operator.code"> {{ operator.mnoName }}</option>
                  </select>
                </div>
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('contacts.amount') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('contacts.amountPlaceholder')" v-model="formValues.amount" :class="{ 'is-invalid': errorsBis['amount'] }" id="amount" @blur="validate('amount')" @keyup="validate_phone_number($event.target.value,$event.target)" />
                    <span class="invalid-feedback">{{ errorsBis['amount']}}</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('contacts.business') }}</label>
                  <select name="business" id="business" class="form-select fs-md-15 text-black shadow-none" @change="handleBusinessChange">
                    <option value="">{{ $t('contacts.select') }}</option>
                    <option v-for="businessItem in business" :value="businessItem.code" :key="businessItem.code"> {{ businessItem.name }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn text-white" style="background-color: #EB9355;">
              <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ $t('contacts.transfer') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Modal Import Contacts -->
  <div class="modal fade" id="importContact" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="storeBulkContact">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('contacts.importContacts') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
            <div v-if="checking==true" style="margin-top: 5%;">
              <h6 style="width: 90%;" :class="(telSizeResult==0)?'text-success fw-bold mb-0': 'text-red fw-bold mb-0'">{{ $t('contacts.phoneSizeError') }} <span style="float:right;">{{ telSizeResult }}</span></h6>
              <h6 style="width: 90%;" :class="(telFormatResult==0)?'text-success fw-bold mb-0': 'text-red fw-bold mb-0'">{{ $t('contacts.phoneFormatError') }} <span style="float:right;">{{ telFormatResult }}</span></h6>
              <h6 style="width: 90%;" :class="(duplicateTelResult==0)?'text-success fw-bold mb-0': 'text-red fw-bold mb-0'">{{ $t('contacts.duplicatePhoneError') }} <span style="float:right;">{{ duplicateTelResult }}</span></h6>
              <h6 v-if="totalChecking==0" class="fw-bold mb-0">{{ $t('contacts.proceedImport') }}</h6>
              <h6 v-if="totalChecking>0" style="color:red" class="text-red fw-bold mb-0">{{ $t('contacts.correctErrors') }}</h6>
            </div>
            <hr v-if="checking==true" />
            <div class="form-group mb-15 mb-sm-20 mb-md-25" style="margin-top: 5%;">
              <div class="row">
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('contacts.download') }}</label>
                  <div>
                    <button class="default-outline-btn bg-transparent position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0" type="button" @click="getModelExcel">
                      {{ $t('contacts.templateFile') }}
                      <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
                    </button>
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('contacts.country') }}</label>
                  <div>
                    <select name="country" id="country" class="form-select fs-md-15 text-black shadow-none" @change="handleCountryChange" required>
                      <option value="">{{ $t('contacts.selectCountry') }}</option>
                      <option value="SN">{{ $t('contacts.senegal') }}</option>
                      <option value="CI">{{ $t('contacts.ivoryCoast') }}</option>
                    </select>
                    <span class="invalid-feedback">{{ errorsBis['phone']}}</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('contacts.uploadFile') }}</label>
                  <div>
                    <input class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="fileUpload" type="file" @change="handleImageUpload" readonly />
                    <span class="invalid-feedback">{{ errorsBis['first_name']}}</span>
                  </div>
                  <button class="default-outline-btn bg-transparent position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0" type="button" style="background-color: #EB9355;visibility: hidden;" data-bs-toggle="modal" data-bs-target="#ckeckingResult" id="toastElement">
                    <i class="flaticon-close position-relative ms-5 top-2 fs-15"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table id="" class="table text-nowrap align-middle mb-0">
                <thead>
                  <tr>
                    <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                      {{ $t('contacts.lastName') }}
                    </th>
                    <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                      {{ $t('contacts.firstName') }}
                    </th>
                    <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                      {{ $t('contacts.phoneNumber') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(massContactItem) in massContact" :key="massContactItem.contact">
                    <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                      <div class="d-flex align-items-center">
                        <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                          {{ massContactItem.last_name}}
                        </div>
                      </div>
                    </th>
                    <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                      {{ massContactItem.first_name}}
                    </td>
                    <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                      {{ massContactItem.contact}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="default-outline-btn bg-transparent fw-medium rounded-1 pt-12 pb-12 ps-25 pe-25" @click="refresh">
              {{ $t('contacts.refresh') }}
            </button>
            <button type="submit" class="btn text-white" style="background-color: #EB9355;" :disabled="checkingResult">
              <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ $t('contacts.save') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, reactive, inject, computed, watch } from "vue";
import axios from 'axios';
import router from '../../../router/index'
import * as yup from 'yup';
import { useI18n } from "vue-i18n";
import { Operator, Contact, Business } from "@/utils/Model";
import { current_permissions } from '../../../utils/permission';
import "intl-tel-input/build/css/intlTelInput.css";
import 'vue-tel-input/vue-tel-input.css';
import intlTelInput from 'intl-tel-input';
import { validate_phone_number, showToast, checkSessionValidate, checkTelSize, checkTelFormat, checkDuplicateTelBis } from "../../../utils/function";
import { read, utils } from 'xlsx';

const backApi = inject('back');
const btnLoad = ref(true);
const checking = ref(false);
const { t } = useI18n();
const selectedOperator = ref('');
const selectedCountry = ref('');
const selectedBusiness = ref(null);
const loader = ref(false);

let token: string | null = localStorage.getItem('login_token');
let codeOrganization: string | null = localStorage.getItem('organization_code');
let codeUser: string | null = localStorage.getItem('code');
let role: string | null = localStorage.getItem('role');

// Toutes les lignes reçues du back
const allContacts = ref(new Array<Contact>());
const business = ref(new Array<Business>());
const operators = ref(new Array<Operator>());
let edit = 0;
let itemCode = '';
let country_code = 'ci';
let phoneMask = process.env.VUE_APP_CI_PHONE_LENTGH;
let telSizeResult = ref(0);
let telFormatResult = ref(0);
let duplicateTelResult = ref(0);
let totalChecking = 0;
let checkingResult = true;
let contactsJson = [];
const massContact = ref([]);
const payoutBalance = ref(0);
let balance: number = 0;
let iti: any;

// --- Pagination / recherche côté FRONT ---
const searchQuery = ref('');
const page = ref(1);
const pageSize = ref(15);

const filteredContacts = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  if (!q) return allContacts.value;
  return allContacts.value.filter((c: any) => {
    const values = [
      c.code,
      c.organization?.name,
      c.first_name,
      c.last_name,
      c.contact
    ];
    return values.some(v => (v ?? '').toString().toLowerCase().includes(q));
  });
});

const filteredTotal = computed(() => filteredContacts.value.length);
const numPages = computed(() => Math.max(1, Math.ceil(filteredTotal.value / pageSize.value)));

const showingFrom = computed(() => filteredTotal.value === 0 ? 0 : (page.value - 1) * pageSize.value + 1);
const showingTo = computed(() => Math.min(page.value * pageSize.value, filteredTotal.value));

const paginatedContacts = computed(() => {
  const start = (page.value - 1) * pageSize.value;
  return filteredContacts.value.slice(start, start + pageSize.value);
});

const goToPage = (targetPage: number) => {
  if (targetPage < 1 || targetPage > numPages.value || targetPage === page.value) return;
  page.value = targetPage;
}

watch(searchQuery, () => {
  page.value = 1;
});

let data: any[] = [];

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorsBis = { 'phone': '', 'first_name': '', 'last_name': '', 'amount': 0 };
const pageLoad = ref(false);

const formValues = reactive({
  phone: "",
  first_name: "",
  last_name: "",
  amount: 0
});

const schema = yup.object({
  phone: yup.string().required('Le numéro de téléphone est requis'),
  first_name: yup.string().required('Le nom est requis'),
  last_name: yup.string().required('Le prénom est requis'),
  amount: yup.number().required('Le montant est requis'),
});

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleBusinessChange(event) {
  selectedBusiness.value = event.target.value;
}

function handleCountryChange(event) {
  selectedCountry.value = event.target.value;
  var j = 0;
  var operatorArr = new Array<Operator>();
  while (j < operatorsTemp.length) {
    if (operatorsTemp[j].countryCode == event.target.value) {
      operatorArr.push(operatorsTemp[j]);
    }
    j++;
  }
  if (operatorArr.length > 0) {
    phoneMask = operatorArr[0].phoneMask;
  }
}

let operatorsTemp = new Array<Operator>();

function getModelExcel() {
  window.open(`/model_contact.xls`, "_blank");
}

const initField = () => {
  formValues.phone = '';
  formValues.first_name = '';
  formValues.last_name = '';
  country_code = '';
  edit = 0;
  errors.value = '';
  errorId.value = '';
  success.value = '';
}

function handlePhone(myvalue, tag) {
  country_code = iti.getSelectedCountryData().iso2;
  let phone_length = 0;
  switch (country_code) {
    case 'ci':
      phone_length = process.env.VUE_APP_CI_PHONE_LENTGH;
      break;
    case 'sn':
      phone_length = process.env.VUE_APP_SN_PHONE_LENTGH;
      break;
    default:
      alert("Sélectionnez un pays");
  }
  validate_phone_number(myvalue, tag, phone_length)
}

const fetchContactsPage = (targetPage: number) => {
  const isPrivileged = role === 'SUPERADMIN' || role === 'BUSINESS' || role === 'SUPPORT';

  let baseUrl = '';
  if (isPrivileged) {
    baseUrl = `${backApi}/secure/contactbooks/extended/`;
  } else {
    baseUrl = `${backApi}/secure/contactbooks?organization=${codeOrganization}`;
  }

  const separator = baseUrl.includes('?') ? '&' : '?';
  const url = `${baseUrl}${separator}page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const loadAllContacts = async () => {
  try {
    const first = await fetchContactsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchContactsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    allContacts.value = collected;
    data = collected;
    page.value = 1;
    console.log('Contacts chargés:', collected.length);
  } catch (error: any) {
    console.error('Erreur chargement contacts:', error);
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const showContact = (code) => {
  axios.get(backApi + '/secure/contactbooks/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    formValues.phone = response.data.contact;
    formValues.first_name = response.data.first_name;
    formValues.last_name = response.data.last_name;
    itemCode = response.data.code;
    country_code = response.data.country_code;
    edit = 1;
    errors.value = '';
    errorId.value = '';
    success.value = '';
    console.log(response.data);
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      } else {
        console.log(error.response);
      }
    }
  });
}

const showTransfert = (code) => {
  axios.get(backApi + '/secure/contactbooks/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    formValues.phone = response.data.contact;
    formValues.first_name = response.data.first_name;
    formValues.last_name = response.data.last_name;
    itemCode = response.data.code;
    country_code = response.data.country_code;
    selectOperatorByCountry(country_code);
    errors.value = '';
    errorId.value = '';
    success.value = '';
    console.log(response.data);
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      } else {
        console.log(error.response);
      }
    }
  });
}

const getBalancePayout = () => {
  axios.post(backApi + `/secure/accounts/balance/payout`, {
    code: codeOrganization,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    payoutBalance.value = response.data.balance;
    balance = response.data.balance;
    console.log(response.data);
  }).catch((error) => {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const getOperators = () => {
  axios.get(backApi + '/public/operators/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    operatorsTemp = response.data;
    console.log(response.data);
  }).catch((error) => {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

function selectOperatorByCountry(countryCode) {
  var j = 0;
  var operatorArr = new Array<Operator>();
  while (j < operatorsTemp.length) {
    if (operatorsTemp[j].countryCode == countryCode) {
      operatorArr.push(operatorsTemp[j]);
    }
    j++;
  }
  operators.value = operatorArr;
}

const getBusiness = () => {
  let param = '';
  param = (role == 'SUPERADMIN') ? '' : `?organization=${codeOrganization}`;
  axios.get(backApi + '/secure/business' + param, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    business.value = response.data.data;
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const showScreen = (code) => {
  itemCode = code;
  errors.value = '';
  errorId.value = '';
}

const cancel = () => {
  itemCode = "";
  errorId.value = "";
  errors.value = "";
}

const refresh = () => {
  itemCode = "";
  checking.value = false;
  massContact.value = [];
  contactsJson = [];
  errors.value = '';
  success.value = '';
  errorId.value = '';
  telSizeResult.value = 0;
  telFormatResult.value = 0;
  duplicateTelResult.value = 0;
  totalChecking = 0;
  checkingResult = true;
  const fileInput = document.getElementById("fileUpload") as HTMLInputElement;
  if (fileInput) fileInput.value = '';
}

const save = () => {
  if (edit == 0) {
    storeContact()
  } else {
    updateContact()
  }
}

const storeBulkContact = () => {
  btnLoad.value = false;
  if (contactsJson.length > 0) {
    try {
      axios.post(`${backApi}/secure/contactbooks/new/bulk`, {
        user: codeUser,
        contacts: contactsJson
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        btnLoad.value = true;
        if (response.status === 200) {
          showToast("Contacts enregistrés avec succès", "green");
          contactsJson = [];
          loadAllContacts();
          // Fermer la modale
          const modal = document.getElementById('importContact');
          if (modal) {
            const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
            if (closeBtn) closeBtn.click();
          }
        }
      }).catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            router.push('/')
          } else {
            errorId.value = error.response.data.errorId;
            errors.value = error.response.data.message;
          }
        }
        btnLoad.value = true;
      });
    } catch (error) {
      console.error(error);
      errors.value = "une erreur inattendue est apparue"
    }
  }
  btnLoad.value = true;
}

const sendMoney = () => {
  btnLoad.value = false;
  if (parseFloat(formValues.amount) > 0 && parseFloat(formValues.amount) <= balance && selectedOperator.value !== '') {
    try {
      schema.validateSync(formValues);

      axios.post(`${backApi}/secure/transactions/init`, {
        clientId: formValues.first_name + " " + formValues.last_name,
        operator: selectedOperator.value,
        amount: parseFloat(formValues.amount),
        mobile: formValues.phone,
        operationType: parseInt(process.env.VUE_APP_PAYOUT_OPTTYPE),
        countryCode: country_code,
        business: selectedBusiness.value,
        successUrl: "https://billing.api/success",
        errorUrl: "https://billing.api/error"
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        btnLoad.value = true;
        if (response.status === 201) {
          showToast("Transfert réussi", "green");
          formValues.amount = 0;
          formValues.phone = '';
          selectedOperator.value = '';
          // Fermer la modale
          const modal = document.getElementById('companyModal1');
          if (modal) {
            const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
            if (closeBtn) closeBtn.click();
          }
        }
      }).catch((error) => {
        if (error.response) {
          if (error.response.status === 401) {
            router.push('/')
          } else {
            errorId.value = error.response.data.errorId;
            errors.value = error.response.data.message;
          }
        }
        btnLoad.value = true;
      });
    } catch (error) {
      console.error(error);
      errors.value = "une erreur inattendue est apparue"
    }
  } else {
    if (parseFloat(formValues.amount) == 0 || parseFloat(formValues.amount) > balance) {
      showToast("Veuillez saisir un montant correct", "red");
    } else {
      showToast("Veuillez sélectionner un opérateur", "red");
    }
  }
  btnLoad.value = true;
}

const storeContact = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);
    axios.post(`${backApi}/secure/contactbooks/new`, {
      last_name: formValues.last_name,
      first_name: formValues.first_name,
      organization: codeOrganization,
      user: codeUser,
      contact: formValues.phone,
      country_code: country_code.toUpperCase()
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Enregistrement effectué avec succès", "green");
        loadAllContacts();
        // Fermer la modale
        const modal = document.getElementById('companyModal');
        if (modal) {
          const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
          if (closeBtn) closeBtn.click();
        }
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
      btnLoad.value = true;
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

const updateContact = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);
    axios.put(`${backApi}/secure/contactbooks/${itemCode}/edit`, {
      last_name: formValues.last_name,
      first_name: formValues.first_name,
      organization: codeOrganization,
      user: codeUser,
      contact: formValues.phone,
      country_code: country_code.toUpperCase()
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      edit = 0;
      itemCode = '';
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Modification effectuée avec succès", "green");
        loadAllContacts();
        // Fermer la modale
        const modal = document.getElementById('companyModal');
        if (modal) {
          const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
          if (closeBtn) closeBtn.click();
        }
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
      btnLoad.value = true;
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

const deleteContact = () => {
  btnLoad.value = false;
  try {
    const headers = {
      'Authorization': `Bearer ${token}`
    }
    const data = {
      code: itemCode
    }
    axios.delete(`${backApi}/secure/contactbooks/delete`, { headers, data })
      .then(response => {
        if (response.status === 200) {
          btnLoad.value = true;
          showToast("Suppression effectuée avec succès", "green");
          loadAllContacts();
          // Fermer la modale
          const modal = document.getElementById('filterLeadModal');
          if (modal) {
            const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
            if (closeBtn) closeBtn.click();
          }
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 401) {
            router.push('/')
          } else {
            errorId.value = error.response.data.errorId;
            errors.value = error.response.data.message;
          }
        }
        btnLoad.value = true;
      });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

const handleImageUpload = (event) => {
  loader.value = false;
  checking.value = false;
  const file = event.target.files[0];
  const reader = new FileReader();
  massContact.value = [];
  contactsJson = [];
  errors.value = '';
  success.value = '';
  errorId.value = '';
  telSizeResult.value = 0;
  telFormatResult.value = 0;
  duplicateTelResult.value = 0;
  totalChecking = 0;

  reader.onload = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = read(data, { type: 'array' });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const jsonData = utils.sheet_to_json(worksheet, { header: 1 });

    var i = 0;
    for (const row of jsonData) {
      if ((row[0] !== undefined && row[0] !== 'NOM') && (row[1] !== undefined && row[1] !== 'PRENOM') && (row[2] !== undefined && row[2] !== 'PHONE_NUMBER')) {
        const user = {
          first_name: row[1],
          last_name: row[0],
          contact: row[2],
          country_code: selectedCountry.value
        };
        contactsJson.push(user);
        i++;
      }
    }

    telSizeResult.value = checkTelSize(contactsJson, phoneMask, "contact");
    telFormatResult.value = checkTelFormat(contactsJson, "contact");
    duplicateTelResult.value = checkDuplicateTelBis(contactsJson, "contact");
    totalChecking = telSizeResult.value + telFormatResult.value + duplicateTelResult.value;

    if (totalChecking == 0) {
      massContact.value = contactsJson;
      checkingResult = false;
    }
  };

  loader.value = true;
  checking.value = true;
  reader.readAsArrayBuffer(file);
}

onMounted(async () => {
  checkSessionValidate(1);
  await loadAllContacts();
  getBalancePayout();
  getOperators();
  getBusiness();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000);

  const inputc = document.querySelector("#phone");
  if (inputc) {
    iti = intlTelInput(inputc, {
      onlyCountries: ["ci", "sn"],
      initialCountry: "auto",
      geoIpLookup: function (callback) {
        fetch("https://ipapi.co/json")
          .then(function (res) { return res.json(); })
          .then(function (data) { callback(data.country_code); })
          .catch(function () { callback("ci"); });
      }
    });
  }

  
  const inputTransfer = document.querySelector("#phone_transfer");
  if (inputTransfer) {
    intlTelInput(inputTransfer, {
      onlyCountries: ["ci", "sn"],
      initialCountry: "auto",
      geoIpLookup: function (callback) {
        fetch("https://ipapi.co/json")
          .then(function (res) { return res.json(); })
          .then(function (data) { callback(data.country_code); })
          .catch(function () { callback("ci"); });
      }
    });
  }
});
</script>